import type {AnchorHTMLAttributes, PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {PaginationSize} from "../types/PaginationSize";

import * as styles from "./PaginationLink.module.css";

interface IProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    isActive?: boolean;
    isDisabled?: boolean;
    size: PaginationSize;
}

type ClassName = keyof typeof styles;

const getLinkSize = (size: PaginationSize) => `paginationLinkSize${capitalize(size)}` as ClassName;

export const PaginationLink = (props: PropsWithChildren<IProps>) => {
    const {className, isActive, isDisabled, size, ...restProps} = props;

    const classes = cn(
        styles.paginationLink,
        styles[getLinkSize(size)],
        {
            [styles.paginationLinkActive]: isActive,
            [styles.paginationLinkDisabled]: isDisabled
        },
        className
    );

    return (
        <a className={classes} {...restProps}>
            {props.children}
        </a>
    );
};
import type {AnchorHTMLAttributes, PropsWithChildren} from "react";
import cn from "classnames";

import {capitalize} from "@pg-mono/nodash";

import {PaginationSize} from "../types/PaginationSize";

import * as styles from "./PaginationLink.module.css";

interface IProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    isActive?: boolean;
    isDisabled?: boolean;
    size: PaginationSize;
}

type ClassName = keyof typeof styles;

const getLinkSize = (size: PaginationSize) => `paginationLinkSize${capitalize(size)}` as ClassName;

export const PaginationLink = (props: PropsWithChildren<IProps>) => {
    const {className, isActive, isDisabled, size, ...restProps} = props;

    const classes = cn(
        styles.paginationLink,
        styles[getLinkSize(size)],
        {
            [styles.paginationLinkActive]: isActive,
            [styles.paginationLinkDisabled]: isDisabled
        },
        className
    );

    return (
        <a className={classes} {...restProps}>
            {props.children}
        </a>
    );
};
